import React, { useState } from 'react'
import { Box, Drawer, Grid, IconButton, Link, Stack, Typography } from '@mui/material'
import { NavLink } from 'react-router-dom'

import { Icon } from '../icon.tsx'
import { APP_ROUTES, EMPTY_VALUE } from '../../constants.ts'
import { useApplicationTheme } from '../../contexts'

import { LogoutButton } from './logout-button.tsx'
import { PROFILE_RENDERERS } from './profile-button.tsx'
import { useUser } from '@/stores/slices/user-slice.ts'

export const MobileMenuIcon = (): React.ReactElement | null => {
  const [showDrawer, setShowDrawer] = useState(false)
  const { theme } = useApplicationTheme()
  const user = useUser()

  if (!user) return null
  return (
    <>
      <IconButton
        size="small"
        color="secondary"
        aria-label="open drawer"
        edge="end"
        onClick={() => setShowDrawer(true)}
        sx={{ color: 'text.primary' }}
      >
        <Icon name="Menu" />
      </IconButton>
      <Drawer
        open={showDrawer}
        PaperProps={{
          sx: {
            height: '100%',
            backgroundColor: 'background.default',
          },
        }}
        disablePortal
        ModalProps={{
          // Better open performance on mobile.
          keepMounted: true,
        }}
        anchor="top"
        onClose={() => setShowDrawer(false)}
      >
        <Grid container flexDirection="column" alignItems="flex-start" sx={{ height: '100%' }}>
          <Grid
            container
            item
            direction="row"
            justifyContent="space-between"
            alignItems="center"
            sx={{ backgroundColor: 'background.paper', px: 2, py: 1.5 }}
          >
            <Grid item>
              <Link component={NavLink} to={APP_ROUTES.SbpPayments}>
                <Icon name={theme === 'dark' ? 'CifraBankLightIcon' : 'CifraBankIcon'} size="initial" />
              </Link>
            </Grid>
            <Grid item>
              <IconButton size="small" sx={{ color: 'text.primary' }} onClick={() => setShowDrawer(false)}>
                <Icon name="Close" />
              </IconButton>
            </Grid>
          </Grid>

          <Grid container item flexDirection="column" justifyContent="space-between" sx={{ p: 2 }} spacing={4}>
            <Grid item>
              <Stack direction="column" gap={2}>
                {PROFILE_RENDERERS.map(({ label, key, renderer }) => (
                  <Box key={key}>
                    <Typography color="text.secondary">{label}</Typography>
                    <Typography>{renderer ? renderer(user) : user[key].toString() ?? EMPTY_VALUE}</Typography>
                  </Box>
                ))}
              </Stack>
            </Grid>
            <Grid item>
              <LogoutButton size="large" onLogout={() => setShowDrawer(false)} />
            </Grid>
          </Grid>
        </Grid>
      </Drawer>
    </>
  )
}
